export enum FundsEnum {
    CMF1 = 1,
    CMF2 = 3,
    CoSelling = 4,
    JMA = 5,
    Jumpstart = 6,
    OPEX = 7,
    ContraToOpex = 8,
    HP = 11,
    CMF1Print	= 13,
    CMF2Print = 14,
    CosellingPrint	= 15,
    JMAPrint = 16,
    JumpstartPrint = 17,
    MDFPrint = 18
}